import { render, staticRenderFns } from "./derivatives-knowledge.vue?vue&type=template&id=04ea03d4&scoped=true&"
import script from "./derivatives-knowledge.vue?vue&type=script&lang=js&"
export * from "./derivatives-knowledge.vue?vue&type=script&lang=js&"
import style0 from "./derivatives-knowledge.vue?vue&type=style&index=0&id=04ea03d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea03d4",
  null
  
)

component.options.__file = "derivatives-knowledge.vue"
export default component.exports